import { useContext } from 'react'
import { PropertyDetailsContext } from '../context/property-details'

export const usePropertyDetailsContext = () => {
    const context = useContext(PropertyDetailsContext)
    if (!context) {
        throw new Error('usePropertyDetailsContext must be used within a PropertyDetailsContextProvider')
    }
    return context
}
